<template>
  <div>
    <el-form
      ref="form"
      :model="formData"
      :rules="rules"
      size="small"
      label-position="top"
    >
      <el-row :gutter="10">
        <el-col :span="24">
          <el-row :gutter="10">
            <el-col :span="8">
              <el-form-item
                :label="$l('form_label_main_material_category') || '1级物料分类'"
                prop="mainMaterialCategory"
                ref="mainMaterialForm"
              >
                <dict-select
                  :disabled="disabled"
                  :placeholder="
                    $l('form_placeholder_main_material_category') ||
                      '请选择1级物料分类'
                  "
                  size="small"
                  clearable
                  filterable
                  v-model="formData.mainMaterialCategory"
                  :body="mainMaterialParams"
                  url="/master/material/category/select"
                  :options="{ label: 'label', value: 'this' }"
                  @change="onMainCategoryChange"
                ></dict-select>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <el-form-item
                :label="$l('form_label_detail_material_category') || '2级物料分类'"
                prop="detailMaterialCategoryCode"
                ref="detailMaterialForm"
              >
                <dict-select
                  :disabled="disabled || !formData.mainMaterialCategoryCode"
                  :placeholder="
                    $l('form_placeholder_detail_material_category') ||
                      '2级物料分类'
                  "
                  size="small"
                  clearable
                  filterable
                  v-model="formData.detailMaterialCategoryCode"
                  :body="detailMaterialParams"
                  url="/master/material/category/select"
                  @change="reset"
                ></dict-select>
              </el-form-item>
            </el-col>
            <el-col :span="8">
              <div style="height: 64px;" class="d-flex align-items-end">
                <b-button
                  :disabled="
                    !formData.mainMaterialCategoryCode ||
                      !formData.detailMaterialCategoryCode
                  "
                  size="sm"
                  variant="outline-success"
                  @click="materialDialogVisible = true"
                >
                  {{ $l('form_label_choose_accessories') || '选择辅料' }}
                </b-button>
              </div>
            </el-col>
          </el-row>
        </el-col>
      </el-row>

      <div class="d-flex">
        <div class="side-frame"></div>
        <div>
          <span style="font-size: 14px; color: #606266">
            {{ $l('form_label_material_base_info') || '物料基础信息' }}
          </span>
        </div>
      </div>
      <div class="mt-2 d-flex">
        <div>
          <span style="font-size: 14px; color: #606266">
            {{ formData.materialNo || '--' }}
          </span>
          <el-divider direction="vertical"></el-divider>
          <span style="font-size: 14px; color: #606266">
            {{ formData.materialName || '--' }}
          </span>
          <el-divider direction="vertical"></el-divider>
          <span style="font-size: 14px; color: #606266">
            {{ formData.materialNameEn || '--' }}
          </span>
        </div>
      </div>

      <el-row :gutter="20">
        <el-col :span="12">
          <el-form-item :label="$l('table_label_material_desc') || '辅料材质'">
            <el-input
              v-model="formData.materialDesc"
              disabled
              size="small"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item :label="$l('table_label_material_spec') || '辅料规格'">
            <el-input
              v-model="formData.materialSpec"
              size="small"
              clearable
              :disabled="!formData.materialNo"
              :placeholder="$l('INDEX.tips_input_placeholder') || '请输入...'"
            ></el-input>
          </el-form-item>
        </el-col>
      </el-row>

      <div class="d-flex mt-3">
        <div class="side-frame"></div>
        <div>
          <span style="font-size: 14px; color: #606266">
            {{ $l('form_label_material_price_use') || '单价/耗料' }}
          </span>
        </div>
      </div>
      <el-row :gutter="10">
        <el-col :span="5">
          <el-form-item :label="$l('form_label_price') || '单价'">
            <el-input-number
              v-model="formData.price"
              controls-position="right"
              :min="0"
              :max="999999.999999"
              :placeholder="$l('form_placeholder_price') || '请输入单价'"
              clearable
              :precision="6"
              :step="0.1"
              style="width: 100%;"
              :disabled="!formData.materialNo"
              v-el-inputnumber-default0
            ></el-input-number>
          </el-form-item>
        </el-col>
        <el-col :span="5">
          <el-form-item :label="$l('table_label_accessories_unit') || '辅料单位'">
            <dict-select
              :placeholder="$l('form_placeholder_accessories_unit') || '请选择辅料单位'"
              size="small"
              clearable
              filterable
              v-model="formData.qtyUnit"
              :body="qtyUnitParams"
              url="/master/common/dict/biz"
              :disabled="!formData.materialNo"
            ></dict-select>
          </el-form-item>
        </el-col>
        <el-col :span="5">
          <el-form-item
            :label="$l('table_label_accessories_usage_qty') || '辅料用量'"
          >
            <el-input
              clearable
              v-model="formData.usageQty"
              :disabled="!formData.materialNo"
              size="small"
              @blur="blurUsageQty"
              :placeholder="
                $l('form_placeholder_accessories_usage_qty') ||
                  '请输入辅料用量'
              "
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="3">
          <el-form-item :label="$l('form_label_sub_total') || '成本小记'">
            <el-input
              v-model="subTotal"
              :placeholder="
                $l('INDEX.form_label_automatic_system_generation') ||
                  '系统自动生成'
              "
              disabled
              style="width: 100%;"
            ></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item :label="$l('form_label_manufacturer') || '厂商'">
            <dict-select
              :placeholder="$l('form_placeholder_scm') || '请选择厂商'"
              size="small"
              clearable
              filterable
              v-model="formData.scmCode"
              :body="scmParams"
              url="/master/common/dict/scm"
              :disabled="!formData.materialNo"
            ></dict-select>
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>

    <el-dialog
      append-to-body
      :title="$l('INDEX.tips_question_title') || '提示信息'"
      :visible.sync="backDialogVisible"
      width="30%"
    >
      <span>{{ $l('INDEX.tips_question_save') || '是否要保存更改' }}</span>
      <span slot="footer" class="dialog-footer">
        <el-button @click="backDialogVisible = false" size="small">
          {{ $l('INDEX.product_dialog_btn_cancel') || '取消' }}
        </el-button>
        <el-button @click="close" size="small">
          {{ $l('INDEX.btn_no_save') || '不保存' }}
        </el-button>
        <el-button @click="save" type="primary" size="small">
          {{ $l('INDEX.btn_save') || '保存' }}
        </el-button>
      </span>
    </el-dialog>

    <choose-material-dialog
      :title="$l('accessories_choose_title') || '添加辅料信息'"
      :visible.sync="materialDialogVisible"
      :productLine="formData.productLine"
      :detailMaterialCategoryCode="formData.detailMaterialCategoryCode"
      :mainMaterialCategoryCode="formData.mainMaterialCategoryCode"
      type="radio"
      @confirm="onMaterialConfirm"
    />
  </div>
</template>

<script>
import validate from '@/libs/util.validate'
import EditLoading from '@/mixins/edit-loading'
import { multiplyRound } from '@/libs/util.number.js'

export default {
  mixins: [EditLoading],
  props: {
    disabled: { type: Boolean, default: false },
    formData: { type: Object, default: () => {} },
    productLine: { type: String, default: '' },
    categoryCode: { type: String, default: '' },
  },
  data() {
    return {
      materialDialogVisible: false,
      backDialogVisible: false,
      scmParams: {},
      subTotal: 0,
      qtyUnitParams: { dictType: 'materialUnit' },
      rules: {
        mainMaterialCategory: [
          {
            required: true,
            message:
              this.$l('form_placeholder_main_material_category') ||
              '请选择1级物料分类',
            trigger: 'change',
          },
        ],
        detailMaterialCategoryCode: [
          {
            required: true,
            message:
              this.$l('form_placeholder_detail_material_category') ||
              '请选择2级物料分类',
            trigger: 'change',
          },
        ],
      },
    }
  },
  watch: {
    'formData.mainMaterialCategory': {
      handler(data) {
        this.$set(
          this.formData,
          'mainMaterialCategoryCode',
          data ? data.value : ''
        )
      },
      immediate: true,
    },
    'formData.price': {
      handler() {
        this.CostCalculation()
      },
      immediate: true,
    },
    'formData.usageQty': {
      handler() {
        this.CostCalculation()
      },
      immediate: true,
    },
  },
  computed: {
    mainMaterialParams() {
      return {
        parentCode: this.formData.productLine,
        materialType: 'M',
      }
    },
    detailMaterialParams() {
      return {
        parentCode: this.formData.mainMaterialCategoryCode,
        materialType: 'M',
      }
    },
  },
  methods: {
    async save() {
      const result = await validate.formValidate([this.$refs.form])
      if (!result) return (this.backDialogVisible = false)

      if (!this.formData.materialNo) {
        this.$message.error(
          this.$l('INDEX.form_placeholder_material') || '请选择物料！'
        )
        return
      }

      this.loadingOpen()
      this.submitSave({
        ...this.formData,
        materialType: 'M',
        subTotal: this.subTotal,
      })
        .then((res) => {
          this.loadingClose()
          if (res.status === 200) {
            this.$message({
              showClose: true,
              message: this.$l('INDEX.tips_save_ok') || '保存成功！',
              type: 'success',
            })
            this.$emit('reload')
            this.close()
          } else {
            this.$message.error(this.$l('INDEX.tips_save_no') || '保存失败！')
          }
        })
        .catch(() => {
          this.loadingClose()
          this.$message.error(this.$l('INDEX.tips_save_no') || '保存失败！')
        })
    },
    async submitSave(params) {
      if (this.formData.proofingCode) {
        return await this.$api.proofingSampleMaterialSaveApi(params)
      }
      return await this.$api.sampleInfoMaterialSaveApi(params)
    },
    onMaterialConfirm(data) {
      if (!data) return
      console.log(data)

      this.changeFormData({
        price: data.price,
        materialCode: data.materialCode,
        materialNo: data.materialNo,
        materialName: data.materialName,
        materialNameEn: data.materialNameEn,
        displayName: data.displayName,
        displayNameEn: data.displayNameEn,
        metadataDesc: data.metadataDesc,
        metadataDescEn: data.metadataDescEn,
        scmCode: data.scmCode,
        materialDesc: data.materialDesc,
        materialSpec: data.materialSpec,
        qtyUnit: data.materialUnit || '',
        materialType: 'M',
      })
    },
    changeFormData(data) {
      const {
        sampleMaterialCode,
        sampleCode,
        proofingCode,
        sortOrder,
        productLine,
        mainMaterialCategoryCode,
        detailMaterialCategoryCode,
        mainMaterialCategory,
      } = this.formData

      const formData = {
        sampleMaterialCode,
        sampleCode,
        proofingCode,
        sortOrder,
        productLine,
        mainMaterialCategoryCode,
        detailMaterialCategoryCode,
        mainMaterialCategory,
        materialType: 'M',
        ...data,
      }
      this.$emit('change', formData)
      this.$emit('update:formData', formData)
      this.CostCalculation()
    },
    reset() {
      this.changeFormData({
        materialNo: '',
        materialName: '',
        materialNameEn: '',
        displayName: '',
        displayNameEn: '',
        metadataDesc: '',
        metadataDescEn: '',
        materialDesc: '',
        materialSpec: '',
        price: 0,
        qtyUnit: '',
        usageQty: '',
        scmCode: '',
      })
    },
    onMainCategoryChange() {
      this.formData.detailMaterialCategoryCode = ''
      this.$refs.detailMaterialForm.resetField()
      this.reset()
    },
    cancel() {
      this.backDialogVisible = true
    },
    close() {
      this.backDialogVisible = false
      this.$emit('close')
    },
    CostCalculation() {
      if (!this.formData) return 0
      const { price, usageQty } = this.formData
      this.subTotal = multiplyRound(price, usageQty, 6)
    },
    blurUsageQty() {
      const num = /^[+]{0,1}(\d+)$|^[+]{0,1}(\d+\.\d+)$/
      if (!num.test(this.formData.usageQty)) {
        this.formData.usageQty = 0
        this.subTotal = 0
        return
      }
      if (this.formData.usageQty > 999999.999999) {
        this.formData.usageQty = 999999.999999
      }
      this.formData.usageQty = parseFloat(this.formData.usageQty).toFixed(6)
    },
  },
}
</script>

<style lang="scss" scoped>
.side-frame {
  padding: 1px 5px;
  border-left: 3px solid $color-primary;
  margin-top: 3px;
  margin-bottom: 3px;
}
</style>
